import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { Grid } from '@material-ui/core';

export const LoaderSkeleton = () => {
  const heights = [ 130, 50, 30, 80, 50, 20 ];
  return (
    <Grid container spacing={ 3 }>
      {
        heights.map((height, i) => {
          return (
          // eslint-disable-next-line react/no-array-index-key
            <Grid item xs={ 12 } key={ `${ height }-${ i }` }>
              <Skeleton
                animation='wave'
                variant='rect'
                width='100%'
                height={ height }
                style={ { borderRadius: '15px' } }
              />
            </Grid>
          );
        })
      }
    </Grid>
  );
};
